export default {
    liquidationAuctionLotsList: [],
    liquidationAuctionLotsHistoryList: [],
};
